import CustomerRoutes from "../../../apiRoutes/CustomerRoutes";
import { api } from "../../ConsumeApiController";


export async function getMySubscriptions() {
    try
    {
        const response = await api.get(CustomerRoutes.Subscriptions.getAll);
        return response;
    }
    catch (error)
    {
        return { success: false, message: error.message };
    }
}


export async function getSubscriptionDetail(id) {
    try {
        const url = CustomerRoutes.Subscriptions.show(id);
        const response = await api.get(url);
        return response;
    } catch (error) {
        return { success: false, message: error.message };
    }
}


